import cx from 'classnames';
import { makeStyles } from '@mui/styles';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Fab from '@mui/material/Fab';
import useScrollTop from './useScrollTop';

const POSITIONS = {
  TOP: 'top',
  BOTTOM_RIGHT: 'bottom_right',
};

const useStyles = makeStyles(({ spacing, transitions, palette, breakpoints }) => ({
  button: {
    position: 'fixed',
    opacity: 0,
    transition: transitions.create(['transform', 'opacity'], {
      duration: transitions.duration.standard,
    }),
    zIndex: 1,
    pointerEvents: 'none',
    color: palette.brand.main,
    background: 'white',
  },
  alignTop: {
    transform: `translateY(${spacing(-3)}) translateX(-50%)`,
    top: spacing(10),
    left: '50%',
    [breakpoints.up('md')]: {
      transform: `translateY(${spacing(-3)})`,
    },
  },
  alignBottomRight: {
    transform: `translateY(${spacing(-3)})`,
    bottom: spacing(3),
    right: spacing(3),
  },
  isVisible: {
    opacity: 1,
    transform: `translateY(0) translateX(-50%)`,
    pointerEvents: 'auto',
    [breakpoints.up('md')]: {
      transform: `translateY(0)`,
    },
  },
  icon: {
    marginRight: spacing(1),
  },
}));

export default function ScrollTop({ children, scrollOffsetTrigger, position = POSITIONS.TOP }) {
  const { handleScrollTop, isVisible } = useScrollTop({ scrollOffsetTrigger });
  const classes = useStyles();
  return (
    <Fab
      variant="extended"
      className={cx(
        classes.button,
        {
          [classes.isVisible]: isVisible,
          [classes.alignTop]: position === POSITIONS.TOP,
          [classes.alignBottomRight]: position === POSITIONS.BOTTOM_RIGHT,
        },
        classes[position]
      )}
      onClick={handleScrollTop}
      tabIndex={-1}
      aria-hidden="true"
    >
      <ArrowUpwardIcon className={classes.icon} /> {children}
    </Fab>
  );
}

ScrollTop.POSITIONS = POSITIONS;
